if (!customElements.get('twa-part-tip')) {
  customElements.define(
    'twa-part-tip',
    class extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('button');
        this.popup = this.querySelector('[popover]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const position = () => {
          const box = this.trigger.getBoundingClientRect();
          const width = this.popup.offsetWidth;
          const height = this.popup.offsetHeight;
          this.popup.style.left = `${Math.max(12, Math.min(innerWidth - width - 12, box.left + box.width / 2 - width / 2))}px`;
          this.popup.style.top = `${box.top > height + 20 ? box.top - height - 9 : box.bottom + 9}px`;
        };
        const show = () => {
          this.popup.showPopover();
          position();
        };
        const hide = () => this.popup.hidePopover();
        this.trigger.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            show();
          },
          options,
        );
        this.trigger.addEventListener(
          'pointerenter',
          (event) => {
            if (event.pointerType === 'mouse') show();
          },
          options,
        );
        this.addEventListener(
          'pointerleave',
          (event) => {
            if (event.pointerType === 'mouse' && document.activeElement !== this.trigger) hide();
          },
          options,
        );
        this.trigger.addEventListener('focus', show, options);
        this.trigger.addEventListener('blur', hide, options);
        this.popup.addEventListener('load', position, { ...options, capture: true });
        window.addEventListener('resize', hide, options);
        window.addEventListener(
          'scroll',
          () => {
            if (this.popup.matches(':popover-open')) position();
          },
          { ...options, capture: true },
        );
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    },
  );
}
